export default "__VITE_ASSET__kHJY9_PY__"